import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  className?: string;
}
export function CTAButton({
  text,
  className = ''
}: CTAButtonProps) {
  return <motion.a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className={`
        inline-flex items-center justify-center
        bg-gold text-carbon font-bold text-lg md:text-xl
        px-8 py-4 rounded-md
        transition-all duration-300
        hover:bg-yellow-400 hover:scale-[1.02]
        active:scale-[0.98]
        animate-pulse-gold
        w-full md:w-auto
        ${className}
      `} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} data-id="element-5">
      {text}
      <ArrowRight className="ml-2 w-6 h-6" data-id="element-6" />
    </motion.a>;
}